import React, { useEffect, useRef, useState } from "react";
import "./ChatBot.scss";
import { Icon } from "@iconify/react";
import cancelIcon from "../../../assets/icons/cancelicon.svg";
import cancelIconWhite from "../../../assets/icons/cancelicon-white.svg";
import chatUserImg from "../../../assets/images/chatUser.svg";

const ChatBot = () => {
  var value = localStorage.getItem("name");
  if (value && value != "undefined") {
    var name = JSON.parse(localStorage.getItem("name"));
  }
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const toggleSidebarLeft = (event) => {
    event.stopPropagation();
    setIsSidebarOpen((prev) => !prev);
  };

  const dropdownRef = useRef(null);
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsSidebarOpen(false);
    }
  };
  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div className="chat-main-container">
      <div className={`chat-left-shade-container ${isSidebarOpen ? "open" : ""}`}>
        <span className="chat-left-shade-span-img">
          <img src={cancelIconWhite} alt="" className="chat-left-shade-crossIcon" onClick={toggleSidebarLeft} />
        </span>
        <div className="chat-left-container" ref={dropdownRef}>
          <div className="w-100">
            <div className="create-newChat-container">
              <Icon icon="tabler:plus" className="create-newChat-plusIcon" />
              NewChat
            </div>
            <div className="history-container">
              <Icon icon="bi:collection-fill" className="create-newChat-collection" />
              <span>History</span>
            </div>
            <div className="callChat-container">
              <h5>Today</h5>
              <div className="callChat-boxes">
                <span>
                  <Icon icon="ph:chat-bold" className="chatIcon" />
                  Hello, i’m fine, how...
                </span>
                <Icon icon="material-symbols:delete-outline" className="deleteIcon" />
              </div>
              <div className="callChat-boxes">
                <span>
                  <Icon icon="ph:chat-bold" className="chatIcon" />
                  Hello, i’m fine, how...
                </span>
                <Icon icon="material-symbols:delete-outline" className="deleteIcon" />
              </div>
              <div className="callChat-boxes">
                <span>
                  <Icon icon="ph:chat-bold" className="chatIcon" />
                  Hello, i’m fine, how...
                </span>
                <Icon icon="material-symbols:delete-outline" className="deleteIcon" />
              </div>
            </div>
          </div>
          <div className="chatUser">
            <span>
              <img src={chatUserImg} alt="" />
            </span>
            {name}
          </div>
        </div>
      </div>
      <div className="chat-right-container">
        <div className="chat-right-inner1-container">
          <Icon icon="iconamoon:menu-burger-horizontal" className="burger-Icon-chatBot" onClick={(event) => toggleSidebarLeft(event)} />
          <div>
            <h1>Group Landev BOT</h1>
            {/* <img src={cancelIcon} alt="" className='cancelIcon' /> */}
          </div>
          <div className="UserChat-container">
            <div className="userMessage">Hello chatGPT,how are you today?</div>
            <div className="AIBotMessage">Hello,i’m fine,how can i help you?</div>
            <div className="userMessage">What is the best programming language?</div>
            <div className="AIBotMessage">
              There are many programming languages ​​in the market that are used in designing and building websites, various applications and other tasks. All these languages ​​are
              popular in their place and in the way they are used, and many programmers learn and use them.
            </div>
          </div>
        </div>
        <div className="chat-right-inner2-container">
          <div className="typePrompt-box">
            <Icon icon="grommet-icons:attachment" className="attachment-icon" />
            <input type="text" placeholder="Send a message " name="" id="" />
          </div>
          <div className="promptInputIcons">
            <Icon icon="ph:microphone" className="micrphoneIcon" />
            <Icon icon="bxl:telegram" className="telegramIcon" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatBot;
